// @ts-nocheck

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux'
import { useLocation } from 'react-router-dom'

import {
  Genre,
  Language,
  CampaignPlatformTypeEnum,
  FlowType,
  CampaignToSchedule,
} from 'Types/index'
import { getCampaignToSchedule } from 'Redux/selectors/campaigns'
import { changeCampaign } from 'Redux/actions/scheduleActions'
import { IconQuestionMark } from 'Stories/Icon/Icon.stories'
import { Hint } from 'Stories/Hint/Hint.stories'
import { HintGuide } from 'Stories/HintGuide/HintGuide.stories'
import GenresHint from 'Containers/CreateCampaignPage/components/GenresHint'
import LanguageHint from 'Containers/CreateCampaignPage/components/LanguageHint'
import GenresHintModal from 'Containers/CreateCampaignPage/components/GenresHintModal'
import LanguageHintModal from 'Containers/CreateCampaignPage/components/LanguageHintModal'
import SimilarArtistPopup from 'Containers/CreateCampaignPage/components/SimilarArtistPopup'
import { WhiteGreenBtn } from 'Stories/Button/Button.stories'
import { getExistingPlaylistsLanguages } from 'Redux/selectors/languages'
import { Desktop, Mobile } from 'Shared/components/Responsive'
import SelectGenres from 'Shared/components/SelectGenres'
import SelectLanguages from 'Shared/components/SelectLanguages'
import ParamsSelect from 'Containers/ui/ParamsSelect'
import CheckboxAntd from 'Containers/ui/CheckboxAntd'
import { HINT_GENRES, HINT_LANGUAGES, CLEAR_HINT } from 'Constants/hints'

import { GenresAndLanguagesSettingsProps } from './props'
import {
  Container,
  SelectTitle,
  WrapperRelative,
  WrapperRelativeLanguages,
  WrapperForLanguageCheckbox,
  NeedHelpButton,
  CenteredBlock,
  HintModal,
} from './styles'

export const GenresAndLanguagesSettings: React.FC<GenresAndLanguagesSettingsProps> = ({
  setIsContinueActive,
  setBudget,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { pathname } = useLocation()
  const urlParts = pathname.split('/')
  const scheduleIndexPartUrl = urlParts.findIndex(
    urlPart => urlPart === 'schedule'
  )
  const campaignID = scheduleIndexPartUrl && urlParts[scheduleIndexPartUrl + 1]

  const accessToken: string = useSelector(
    (state: RootStateOrAny) => state.spotifyToken.accessToken
  )
  const allGenres: Array<Genre> = useSelector(
    (state: RootStateOrAny) => state.genres.genres
  )

  const campaignDetails: CampaignToSchedule = useSelector(getCampaignToSchedule)

  const languages: Array<Language> = useSelector(getExistingPlaylistsLanguages)

  const [componentDidMount, setComponentDidMount] = useState(false)
  const [selectedGenres, setSelectedGenres] = useState([])
  const [selectedLanguages, setSelectedLanguages] = useState([])
  const [genresSearchMobileMode, setGenreSearchMobileMode] = useState(false)
  const [languageSearchMobileMode, setLanguageSearchMobileMode] = useState(
    false
  )
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false)
  const [isNeedHelpModal, setIsNeedHelpModal] = useState(false)
  const [hintGuide, setHint] = useState({ component: null, name: null })
  const [modalGenre, setModalValueGenre] = useState(false)
  const [modalVocal, setModalValueVocal] = useState(false)

  const handleSetGenres = genres => {
    setBudget(0)
    const language_ids = selectedLanguages.map(el => el.value)
    dispatch(
      changeCampaign({
        campaign_id: campaignDetails?.id,
        genres_ids: genres.map(el => el.value),
        languages_ids: isCheckboxChecked ? language_ids : [...language_ids, 3],
        moods_ids: null,
        max_price: null,
      })
    )
    setSelectedGenres(genres)
  }

  const handleSetLanguages = languages => {
    setBudget(0)
    const language_ids = languages.map(el => el.value)
    dispatch(
      changeCampaign({
        campaign_id: campaignDetails?.id,
        genres_ids: selectedGenres.map(el => el.value),
        languages_ids: isCheckboxChecked ? language_ids : [...language_ids, 3],
        moods_ids: null,
        max_price: null,
      })
    )
    setSelectedLanguages(languages)
  }

  const handleSetVocalCheckbox = value => {
    setBudget(0)
    const language_ids = selectedLanguages.map(el => el.value)
    dispatch(
      changeCampaign({
        campaign_id: campaignDetails?.id,
        genres_ids: selectedGenres.map(el => el.value),
        languages_ids: value ? language_ids : [...language_ids, 3],
        moods_ids: null,
        max_price: null,
      })
    )
    setIsCheckboxChecked(value)
  }

  useEffect(() => {
    if (selectedGenres.length >= 1 && selectedLanguages.length >= 1) {
      setIsContinueActive(true)
    } else {
      setIsContinueActive(false)
    }
  }, [selectedGenres, selectedLanguages, isCheckboxChecked])

  useEffect(() => {
    if (
      !componentDidMount &&
      campaignDetails &&
      campaignDetails.id === campaignID
    ) {
      const filteredLanguages = campaignDetails?.languages?.filter(
        el => el.id !== 3
      )

      const areLanguagesStrict = campaignDetails?.languages?.find(
        el => el.id === 3
      )
      setSelectedGenres(
        campaignDetails?.genres?.map(el => ({
          label: el.name,
          value: el.id,
          playlistsCount: el.playlistsCount,
        }))
      )
      setSelectedLanguages(
        filteredLanguages?.map(el => ({
          label: el.name,
          value: el.id,
        }))
      )
      setIsCheckboxChecked(!areLanguagesStrict)
      setComponentDidMount(true)
    }
  }, [campaignDetails, componentDidMount, campaignID])

  const needHelpModalToggle = () => setIsNeedHelpModal(!isNeedHelpModal)

  const handleSetHint = hint => {
    if (hint === HINT_GENRES) {
      setHint({ component: <GenresHint />, name: HINT_GENRES })
    }

    if (hint === HINT_LANGUAGES) {
      setHint({ component: <LanguageHint />, name: HINT_LANGUAGES })
    }

    if (hint === CLEAR_HINT) {
      setHint({ component: null, name: null })
    }
  }

  const onChangeGenresFromArtist = artist_genres => {
    const isFalse = artist_genres.filter(item => item.isCheked === false)
    const isTrue = artist_genres
      .filter(item => item.isCheked === true)
      .map(item => ({
        label:
          item.genre_name.slice(0, 1).toUpperCase() + item.genre_name.slice(1),
        value: item.id,
      }))

    if (isFalse.length === 0 && isTrue.length === 0) return

    const genresIsFalse = selectedGenres.filter(
      genres => !isFalse.find(genre => genres.value === genre.id)
    )

    const genresIsTrue = isTrue.filter(
      item => !selectedGenres.find(genres => genres.value === item.value)
    )

    handleSetGenres([...genresIsFalse, ...genresIsTrue])
  }

  return (
    <>
      {hintGuide && hintGuide.component && (
        <HintModal languages={hintGuide.name === 'hintLanguages'}>
          {hintGuide.component}
          <CenteredBlock>
            <WhiteGreenBtn
              color="white"
              onClick={() => handleSetHint('clearHint')}
            >
              {t('scheduleCampaignPage.gotIt')}
            </WhiteGreenBtn>
          </CenteredBlock>
        </HintModal>
      )}
      <Container>
        <div>
          <SelectTitle>
            {t('scheduleCampaignPage.chooseTargetGenres')}
            <Desktop>
              <HintGuide
                className="hint_genres"
                hintName="hintGenres"
                setHintName={handleSetHint}
                currentHint={hintGuide && hintGuide.name}
              />
            </Desktop>
            <Mobile>
              <Hint onClick={setModalValueGenre}>
                <IconQuestionMark />
              </Hint>
              <GenresHintModal
                isOpen={modalGenre}
                toggle={setModalValueGenre}
              />
            </Mobile>
          </SelectTitle>
          <WrapperRelative>
            <SelectGenres
              selectedGenres={selectedGenres}
              setSelectedGenres={handleSetGenres}
              allGenres={allGenres}
              campaignType={CampaignPlatformTypeEnum.SPOTIFY}
              campaignId={campaignID}
              onMobileSearchOpen={() => {
                setGenreSearchMobileMode(true)
              }}
            />
            <ParamsSelect
              isSearchMode={genresSearchMobileMode}
              placeholder="Genre name"
              itemsType="genres"
              listedItems={allGenres || []}
              selectedItems={selectedGenres}
              setSelectedItems={handleSetGenres}
              flow={FlowType.scheduling}
              campaignId={campaignID}
              onCloseClick={() => {
                setGenreSearchMobileMode(false)
              }}
            />
          </WrapperRelative>
        </div>

        <Desktop>
          <NeedHelpButton onClick={needHelpModalToggle}>
            {t('createCampaignPage.needHelpToDefineGenres')}
          </NeedHelpButton>
        </Desktop>
        <Mobile>
          <NeedHelpButton onClick={needHelpModalToggle}>
            {t('createCampaignPage.needHelpToDefineGenres')}
          </NeedHelpButton>
        </Mobile>

        <div>
          <SelectTitle>
            {t('scheduleCampaignPage.chooseTargetLanguages')}
            <Desktop>
              <HintGuide
                className="hint_languages"
                hintName="hintLanguages"
                setHintName={handleSetHint}
                currentHint={hintGuide && hintGuide.name}
              />
            </Desktop>
            <Mobile>
              <Hint onClick={setModalValueVocal}>
                <IconQuestionMark />
              </Hint>
              <LanguageHintModal
                isOpen={modalVocal}
                toggle={setModalValueVocal}
              />
            </Mobile>
          </SelectTitle>
          <WrapperRelativeLanguages>
            <SelectLanguages
              selectedLanguages={selectedLanguages}
              setSelectedLanguages={handleSetLanguages}
              languages={languages}
              campaignType={CampaignPlatformTypeEnum.SPOTIFY}
              campaignId={campaignID}
              onMobileSearchOpen={() => {
                setLanguageSearchMobileMode(true)
              }}
            />
            <ParamsSelect
              isSearchMode={languageSearchMobileMode}
              placeholder="No vocal"
              itemsType="languages"
              listedItems={languages || []}
              selectedItems={selectedLanguages}
              setSelectedItems={handleSetLanguages}
              flow={FlowType.scheduling}
              campaignId={campaignID}
              onCloseClick={() => {
                setLanguageSearchMobileMode(false)
              }}
            />
          </WrapperRelativeLanguages>
          <WrapperForLanguageCheckbox>
            <CheckboxAntd
              checked={isCheckboxChecked}
              onChange={() => handleSetVocalCheckbox(!isCheckboxChecked)}
            />
            <div>{t('createCampaignPage.targetOnlySelectedLanguages')}</div>
          </WrapperForLanguageCheckbox>
        </div>
      </Container>
      <SimilarArtistPopup
        accessToken={accessToken}
        modal={isNeedHelpModal}
        toggle={needHelpModalToggle}
        selectedGenres={[]}
        flow="scheduling"
        onChangeGenresFromArtist={onChangeGenresFromArtist}
      />
    </>
  )
}
